/** Organization team access roles (create / update member). Maps to DB DefaultPondRole + flags. */
export const TEAM_ACCESS_ROLES = [
  {
    value: "owner",
    title: "Owner",
    icon: "fa-crown",
    description:
      "Full access to everything. Can delete Anglers, Pond Managers, and Pond Management Staff.",
    isOwner: true,
    isAdmin: true,
    defaultPondRole: null,
  },
  {
    value: "pond_manager",
    title: "Pond Manager",
    icon: "fa-clipboard-list",
    description:
      "Input, view, print, and download all data. Can assign Pond Management Staff to ponds.",
    isOwner: false,
    isAdmin: false,
    defaultPondRole: "scientist",
  },
  {
    value: "pond_staff",
    title: "Pond Management Staff",
    icon: "fa-users",
    description:
      "Can be added by the Pond Owner or Pond Manager. Input and download data on assigned ponds.",
    isOwner: false,
    isAdmin: false,
    defaultPondRole: "staff",
  },
  {
    value: "angler",
    title: "Angler",
    icon: "fa-mobile-alt",
    description:
      "Added by the Pond Owner. Access through the app to add catch and sampling data only.",
    isOwner: false,
    isAdmin: false,
    defaultPondRole: "angler",
  },
];

export const POND_ASSIGN_ACCESS_ROLES = TEAM_ACCESS_ROLES.filter((r) => r.value !== "owner");

export function getTeamAccessRole(value) {
  return TEAM_ACCESS_ROLES.find((r) => r.value === value) || TEAM_ACCESS_ROLES[2];
}

export function teamAccessRoleFromStaff(staff) {
  if (!staff || typeof staff !== "object") return "pond_staff";
  if (staff.IsFisherOwner === true || staff.IsFisherOwner === 1 || staff.IsFisherOwner === "1") {
    return "owner";
  }
  const pondRole = String(staff.DefaultPondRole || staff.defaultPondRole || "").toLowerCase();
  if (pondRole === "scientist") return "pond_manager";
  if (pondRole === "staff") return "pond_staff";
  if (pondRole === "angler") return "angler";
  if (staff.IsAdmin === true || staff.IsAdmin === 1 || staff.IsAdmin === "1") {
    return "pond_manager";
  }
  return "pond_staff";
}

export function resolveStaffPondRole(staff) {
  const access = getTeamAccessRole(teamAccessRoleFromStaff(staff));
  return access.defaultPondRole || "staff";
}

/** Team list: name pill + role column styling */
export const TEAM_LIST_ROLE_DISPLAY = {
  owner: {
    title: "Owner",
    icon: "fa-crown",
    pillClass: "bg-primary bg-opacity-10 text-primary border-primary",
    roleBorder: "border-primary text-primary",
  },
  scientist: {
    title: "Scientist",
    icon: "fa-flask",
    pillClass: "bg-info bg-opacity-10 text-info border-info",
    roleBorder: "border-info text-info",
  },
  pond_manager: {
    title: "Pond Manager",
    icon: "fa-clipboard-list",
    pillClass: "bg-success bg-opacity-10 text-success border-success",
    roleBorder: "border-success text-success",
  },
  pond_staff: {
    title: "Pond Management Staff",
    icon: "fa-users",
    pillClass: "bg-primary bg-opacity-10 text-primary border-primary",
    roleBorder: "border-primary text-primary",
  },
  angler: {
    title: "Angler",
    icon: "fa-mobile-alt",
    pillClass: "bg-warning bg-opacity-10 text-warning border-warning",
    roleBorder: "border-warning text-warning",
  },
};

export function isLinkedScientistStaff(row) {
  if (!row || typeof row !== "object") return false;
  const isDirect = row.isDirectStaff === 1 || row.isDirectStaff === "1";
  if (isDirect) return false;
  if (row.isAssociatedStaff === 1 || row.isAssociatedStaff === "1") return true;
  return (
    row.IsIndependentScientist === true ||
    row.IsIndependentScientist === 1 ||
    row.IsIndependentScientist === "1"
  );
}

export function teamListRoleKey(row) {
  if (!row || typeof row !== "object") return "pond_staff";
  if (row.IsFisherOwner === true || row.IsFisherOwner === 1 || row.IsFisherOwner === "1") {
    return "owner";
  }
  if (isLinkedScientistStaff(row)) return "scientist";
  return teamAccessRoleFromStaff(row);
}

export function getTeamListRoleDisplay(row) {
  const key = teamListRoleKey(row);
  return TEAM_LIST_ROLE_DISPLAY[key] || TEAM_LIST_ROLE_DISPLAY.pond_staff;
}
